// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"724":"f35e6a0f","746":"f35e6a0f","3640":"d1a727b0","3731":"cb163237","5147":"f35e6a0f","6906":"31a687ee","9600":"b62a5bae"}[chunkId] + ".chunk.css";
};